// LogoSelectStep.tsx — step 'logo-select' del onboarding.
// Qué hace: muestra las imágenes del scan ordenadas (logos primero) para que el
//   usuario elija su logo, lo salte o vaya a la vía alternativa (logo-alt).
// Qué exporta: LogoSelectStep.
// Quién lo usa: CreateWorkspaceModal.

import { ClassifiedImage } from '@agency-smm/shared';
import { Button } from '../../Button';
import { ModalActions } from '../../Modal';
import { WizardStep } from '../types';
import { ImgGrid, ImgItem, Badge } from '../styled';

interface Props {
  allImages: ClassifiedImage[];
  selectedLogo: string | null;
  setSelectedLogo: React.Dispatch<React.SetStateAction<string | null>>;
  confirmLogo: () => void;
  user: (text: string) => void;
  novah: (text: string) => void;
  pushStep: (next: WizardStep) => void;
}

export function LogoSelectStep({
  allImages, selectedLogo, setSelectedLogo, confirmLogo, user, novah, pushStep,
}: Props) {
  const logos = allImages.filter(i => i.category === 'logo');
  const photos = allImages.filter(i => i.category !== 'logo');
  const sortedImages = [...logos, ...photos];
  return (
    <>
      {logos.length > 0 && (
        <div style={{ fontSize: 11, fontWeight: 600, color: '#94A3B8', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 4 }}>
          Possible logos ({logos.length})
        </div>
      )}
      <ImgGrid>
        {sortedImages.map((img, i) => (
          <ImgItem
            key={i}
            $selected={selectedLogo === img.url}
            onClick={() => setSelectedLogo(selectedLogo === img.url ? null : img.url)}
          >
            <img src={img.url} alt={`Image ${i + 1}`} onError={e => { (e.target as HTMLImageElement).style.display = 'none'; }} />
            {selectedLogo === img.url && <Badge>✓</Badge>}
            {img.category === 'logo' && selectedLogo !== img.url && (
              <div style={{ position: 'absolute', top: 2, right: 2, fontSize: 8, background: 'rgba(59,130,246,0.8)', color: '#fff', padding: '1px 4px', borderRadius: 4, fontWeight: 700 }}>LOGO</div>
            )}
          </ImgItem>
        ))}
      </ImgGrid>
      <ModalActions>
        <Button type="button" $variant="ghost" $size="sm" onClick={() => {
          user("None of these is my logo");
          setSelectedLogo(null);
          novah("No worries! You can paste a logo URL or upload a file.");
          pushStep('logo-alt');
        }}>
          None of these
        </Button>
        <Button type="button" $variant="outline" $size="sm" onClick={() => { setSelectedLogo(null); confirmLogo(); }}>
          Skip
        </Button>
        <Button type="button" $size="sm" onClick={confirmLogo} disabled={!selectedLogo}>
          Confirm Logo
        </Button>
      </ModalActions>
    </>
  );
}
